import { useState } from "react";
import { connect } from "react-redux";
import { Modal } from "antd";
import { Note } from "../../../../../helbest";
import { API } from "../../../../../request/api";
import { Input } from "antd";
import styles from "./NewName.module.css";

// icons
import { ReactComponent as BottomArrow } from "../../../../../assets/svg/up-down-arrow.svg";
import IconCross from "../../../../../assets/images/icons/cross_rv.png";
import UserIcon from "../../../../../assets/svg/user-edit.svg";
import { ReactComponent as UserEditIcon } from "../../../../../assets/svg/user-edit.svg";
import Button from "../../../../components/ui/Button";
import { useTranslation } from "react-i18next";

const SelectName = (props) => {
  const { isVisible, closeModal, mobileNumber, setMustRefetchUserInfo } = props;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const { t } = useTranslation();

  const clearData = () => {
    setFirstName("");
    setLastName("");
  };

  const submitFullName = () => {
    API.post
      .customerInfo(firstName, lastName, mobileNumber)
      .then((response) => {
        if (response.code === 200) {
          Note.success(response.message);
          clearData();
          setMustRefetchUserInfo(true);
          closeModal();
        } else {
          Note.error(response.message);
        }
      })
      .catch((error) => {
        console.log("Error : ", error);
        Note.error(error.message);
      });
  };

  return (
    <Modal
      title={
        <div className="flex flex-column center-content icon_modal_my_new_car center column m-5">
          <img className="cars-modal-icon" src={UserIcon} alt="name" />
          <label>{t("new_service.select_name_modal.title")}</label>
        </div>
      }
      open={isVisible}
      okButtonProps={{
        className: "flex-stretch",
      }}
      cancelButtonProps={{
        className: "flex-stretch",
        danger: true,
        ghost: true,
      }}
      cancelText={t("common.cancel")}
      okText={t("common.submit")}
      onOk={() => submitFullName()}
      onCancel={() => {
        closeModal();
        clearData();
      }}
      footer={(_, { OkBtn, CancelBtn }) => (
        <div className="flex gap-2">
          <CancelBtn />
          <OkBtn />
        </div>
      )}
    >
      <div className="flex column">
        <div className="create_car_box flex column center">
          <p className={styles.TitleInput}>
            {t("new_service.select_name_modal.first_name")}
          </p>
          <div className="relative">
            <UserEditIcon className={styles.InputIcon} width={24} />
            <Input
              name="customer_first_name"
              className={`${styles.Input} ${styles.NewServiceInput} mb-2`}
              style={{ paddingLeft: 38 }}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder={t("common.first_name")}
              value={firstName}
            />
          </div>
          <p className={styles.TitleInput}>
            {t("new_service.select_name_modal.last_name")}
          </p>
          <div className="relative">
            <UserEditIcon className={styles.InputIcon} width={24} />
            <Input
              name="customer_last_name"
              className={`${styles.Input} ${styles.NewServiceInput} mb-2`}
              style={{ paddingLeft: 38 }}
              onChange={(e) => setLastName(e.target.value)}
              placeholder={t("common.last_name")}
              value={lastName}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

const mstp = (state) => ({
  Login: state.Login,
});
export default connect(mstp)(SelectName);
